<script>
export default {
    name: "Speaker",
    functional: true,
    props: {
        speaker: {
            type: Object,
        },
        value: {
            type: Number,
        },
        language: {
            type: String,
            default: "ru",
        },
    },
}
</script>

<template functional>
    <span :class="{'speaker-no-active': !props?.speaker?.is_active}" class="speaker">
        <span class="text-id_eps mr-2">{{ props?.speaker?.id_speaker_eps || props?.value }}</span>
        <span class="text-name">{{ props?.speaker['name_' + props.language] }}</span>
    </span>
</template>

<style scoped lang="css">
.speaker-no-active {
    text-decoration: line-through;
}

.text-id_eps {
    opacity: 0.5;
    width: 60px;
    display: inline-block;
}
</style>
